import React, { Component } from "react";
import { Container, Row, Col } from 'reactstrap';

class ReleaseHistory extends Component {
    componentDidMount() {
        document.title = "Release History - Job Search Tracker";
    }

    render() {
        return (
            <Container className="mt-4 p-t-10">
                <Row className="text-center mb-3">
                    <Col>
                        <h1>Release History</h1>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <h2>April 27, 2026 - Release 6.0</h2>
                        <ul>
                            <li>Add Dashboard Report Table soft encoding with configuration page</li>
                            <li>Add Drop Down Option soft encoding with configuration page</li>
                            <li>Expand Job Posting List, Opportunity List, and Report Tables and include additional fields</li>
                            <li>Add export of table data to TSV format</li>
                            {/* <li>On Save, prevent double saves</li> */}
                        </ul>
                        <h2>November 1, 2025 - Release 5.2</h2>
                        <ul>
                            <li>Add Opportunity Status to List View</li>
                            <li>Add Preliminary SSL Certificate Support</li>
                            <li>Job Posting Edit Field adjustments</li>
                            <li>Add two new statistics rows to Dashboard</li>
                            {/* <li>On Save, when navigating to calling page, refresh page data</li> */}

                        </ul>
                        <h2>April 27, 2025 - Release 5.1</h2>
                        <ul>
                            <li>Set Default Report Date to January 1, 2025</li>
                            <li>Add Opportunity City Location and Recruiter Company to List View</li>
                            <li>Add Confirmation Modal for Delete and Clear Buttons</li>
                            {/* <li>On Save, when navigating to calling page, refresh page data</li> */}
                            {/* <li>Add New Job Posting (no ID) route back to react router</li> */}
                            {/* <li>Allow Max Job Posting Edit Tech String Length and make text area</li> */}
                            {/* <li>Email Opportunity List: less data (retrieve only necesary columns)</li> */}
                            {/* <li>Correct Page Titles (Login, index.html)</li> */}
                            {/* <li>Show Comments in date acending order</li> */}
                        </ul>
                        <h2>March 20, 2025 - Release 5</h2>
                        <ul>
                            <li>Docker and Web Server Support (Nginx + Gunicorn)</li>
                            <li>Enabled Users to edit their name and password</li>
                            <li>Google Analytics</li>
                            <li>Added Job Site Cache</li>
                            <li>Enabled Django Logging</li>
                            <li>Moved to Production Database</li>
                            <li>Reduced Back end Requests (once instead of double render twice)</li>
                        </ul>
                        <h2>January 14, 2025 - Release 4</h2>
                        Added Multi-User Support!  Impacts:
                        <ul>
                            <li>Added back end custom user module and added user field to job postings, job sites, and opportunities</li>
                            <li>Added back end authentication, token refresh, and logout</li>
                            <li>New Login and Register Pages</li>
                            <li>New Menu organization dependant on whether logged in or not</li>
                            <li>Converted all Class Components to Functional Components</li>
                            <li>Enabled React.Fetch for API Authentication Tokens</li>
                        </ul>
                        <h2 className="mt-5">November 14, 2024 - Release 3</h2>
                        <ul>
                            <li>Added Dashboard with dynamically calculated statistics</li>
                            <li>Added Static Boolean Search Page</li>
                            <li>Added Additional Field Validations</li>
                            <li>Fixed a few minor bugs and a race condition</li>
                        </ul>

                        <h2 className="mt-5">October 25, 2024 - Release 2</h2>
                        <ul>
                            <li>Added Job Sites and Job Postings</li>
                            <li>Added Reports</li>
                            <li>Added Data Table Filters</li>
                            <li>Static Page Menu Consolidation</li>
                        </ul>

                        <h2 className="mt-5">September 11, 2024 - Release 1</h2>
                        <ul>
                            <li>Initial Release</li>
                        </ul>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default ReleaseHistory;